export const getUniqueFilename = (filename: string, existingFileNames: string[]): string => {
  const existingFileNamesSet = new Set(existingFileNames)

  const match = /^(.*?)(\.[^.]*)?$/.exec(filename)
  const baseName = match?.[1]
  const extension = match?.[2] ?? ''

  let uniqueFileName = filename
  let counter = 1

  while (existingFileNamesSet.has(uniqueFileName)) {
    uniqueFileName = `${baseName}(${counter})${extension}`
    counter++
  }

  return uniqueFileName
}
